import { Component, OnInit } from '@angular/core';
import { AccountService } from '../../../shared/service/account/account.service';
import { StoreType, DispCoordinates } from '../../../shared/model/dispensary/dispensary-dsp.model';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store/app.state';
import { Observable } from 'rxjs';
import { LocalStorageUtils } from '../../../shared/util/local-storage.utils';
import { ActivatedRoute, Router } from '@angular/router';
import { LogOut } from '../../../store/authentication/auth.action';
import { PublicBaseComponent } from '../../public/public-base.component';
import { NumberProduct } from '../../../store/reservation/reservation.action';
import { ChangeDispensary, ChangeMenuActive } from '../../../store/menu/menu.action';


@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss']
})

export class AccountComponent extends PublicBaseComponent implements OnInit {

  store_id: any;
  controlLogoutClass = 'hidden';

  authState: Observable<any>;
  user_id: any;
  profile: any;
  upReservation: any;
  order_id: any;
  dispensaryCoordinates: DispCoordinates;

  listReservation = [];
  storeType = StoreType.Pickup;
  StoreType = StoreType;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private store: Store<AppState>,
    private accountService: AccountService,
  ) {
    super();
    this.controlLogoutClass = 'hidden';
    this.authState = store.select('authentication');
    this.store_id = this.route.snapshot.paramMap.get('id');
    localStorage.setItem('store_id',`${this.store_id}`);
    this.store.dispatch(new ChangeDispensary({ disp_id: this.store_id }));
  }

  ngOnInit() {
    this.accountService.getAccountInfo(this.store_id).subscribe(rs => {
      if (rs && rs['profile']) {
        this.profile = rs['profile'];
        if (rs['profile'].avatar) {
          this.profile.avatar = this.imgBaseUrl + '/' + rs['profile'].avatar;
        } else {
          this.profile.avatar = '';
        }

        this.profile.active_points = rs['active_points'];
        // tslint:disable-next-line:max-line-length
        this.profile.active_points = (this.profile.active_points === '' || this.profile.active_points === null) ? 0 : this.profile.active_points;

        LocalStorageUtils.saveValue('profile', JSON.stringify(rs['profile']));

        const upcoming_reservations = rs['upcoming_reservations'];
        const past_reservations = rs['past_reservations'];
        const dispensary = rs['dispensary'];
        this.storeType = dispensary['store_type'];
        this.dispensaryCoordinates = { lat: +rs['dispensary']['lat'], lng: +rs['dispensary']['lng'] };
        const past_last_reservations = [];
        if (upcoming_reservations && upcoming_reservations.length > 0) {
          this.upReservation = upcoming_reservations[0];
          this.order_id = upcoming_reservations[0].order_id;
          this.listReservation = upcoming_reservations.map(obj => {
            obj.dispensary = dispensary;
            return obj;
          });
        } else {
          if (past_reservations && past_reservations.length > 0) {
            this.upReservation = past_reservations[0];
            this.order_id = past_reservations[0].order_id;
            past_last_reservations.push(past_reservations[0]);
            this.listReservation = past_last_reservations.map(obj => {
              obj.dispensary = dispensary;
              return obj;
            });
          } else {
            this.upReservation = {};
            this.order_id = '';
            this.listReservation = [];
          }
        }
        if (dispensary) {
          this.upReservation.dispensary = dispensary;
          if (this.upReservation.dispensary && this.upReservation.dispensary.logo) {
            this.upReservation.dispensary.logo = this.imgBaseUrl + '/' + this.upReservation.dispensary.logo;
          } else {
            this.upReservation.dispensary.logo = '';
          }
        }
      }
    });
  }

  goToEditProfile() {
    if (this.store_id && this.store_id !== '') {
      this.router.navigate([`${this.store_id}/account/profile`]);
    }
  }

  showLogoutForm() {
    this.controlLogoutClass = '';
  }

  hideLogoutForm() {
    this.controlLogoutClass = 'hide';
  }

  logOut() {
    this.store.dispatch(new LogOut());
    this.router.navigate([`${this.store_id}/`]);
    this.store.dispatch(new NumberProduct({ numberProduct: 0 }));
    this.store.dispatch(new ChangeMenuActive({ activeMenu: 'menu' }));
    LocalStorageUtils.removeItem('GL_CART_NOT_LOGIN');
  }

  goToReservation(order_id: number | string) {
    this.router.navigate([`${this.store_id}/account/reservation/${order_id}`]);
  }
}
